import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    getCompanies as getCompaniesApi,
    getCompaniesByUser as getCompaniesByUserApi,
    getCompanyById as getCompanyByIdApi,
    addCompany as addCompanyApi,
    updateCompany as updateCompanyApi,
    deleteCompany as deleteCompanyApi,
    addCompanySignature as addCompanySignatureApi,
    getEstablishments as getEstablishmentsApi,
    addEstablishment as addEstablishmentApi,
    updateEstablishment as updateEstablishmentApi,
    deleteEstablishment as deleteEstablishmentApi,
    getEmissionPoints as getEmissionPointsApi,
    addEmissionPoint as addEmissionPointApi,
    updateEmissionPoint as updateEmissionPointApi,
    deleteEmissionPoint as deleteEmissionPointApi,
} from "./api";
import { toast } from "react-toastify";

export const getCompanies = createAsyncThunk(
    "companies/getCompanies",
    async () => {
        try {
            const response: any = await getCompaniesApi();
            return response;
        } catch (error) {
            toast.error("Error al obtener las compañías");
            throw error;
        }
    }
);

export const getCompaniesByUser = createAsyncThunk(
    "companies/getCompaniesByUser",
    async (userId: string) => {
        try {
            const response: any = await getCompaniesByUserApi(userId);
            return response;
        } catch (error) {
            toast.error("Error al obtener las compañías del usuario");
            throw error;
        }
    }
);

export const getCompanyById = createAsyncThunk(
    "companies/getCompanyById",
    async (id: string) => {
        try {
            const response: any = await getCompanyByIdApi(id);
            return response;
        } catch (error) {
            toast.error("Error al obtener la compañía");
            throw error;
        }
    }
);

export const addCompany = createAsyncThunk(
  "companies/addCompany",
  async (company: any) => {
    try {
      const response: any = await addCompanyApi(company);
      toast.success("Compañía agregada con éxito");
      return response;
    } catch (error) {
      toast.error("Error al agregar la compañía");
      throw error;
    }
  }
);

export const updateCompany = createAsyncThunk(
  "companies/updateCompany",
  async (company: any) => {
    try {
      const response: any = await updateCompanyApi(company);
      toast.success("Compañía actualizada con éxito");
      return response;
    } catch (error) {
      toast.error("Error al actualizar la compañía");
      throw error;
    }
  }
);

export const deleteCompany = createAsyncThunk(
  "companies/deleteCompany",
  async (companyId: string) => {
    try {
      await deleteCompanyApi(companyId);
      toast.success("Compañía eliminada con éxito");
      return companyId;
    } catch (error) {
      toast.error("Error al eliminar la compañía");
      throw error;
    }
  }
);

export const addCompanySignature = createAsyncThunk(
  "companies/addCompanySignature",
  async (signatureData: any) => {
    try {
      const response: any = await addCompanySignatureApi(signatureData);
      toast.success("Firma digital agregada con éxito");
      return response;
    } catch (error: any) {
      toast.error(error || "Error al agregar la firma digital");
      throw error;
    }
  }
);

// Establishments
export const getEstablishments = createAsyncThunk(
    "companies/getEstablishments",
    async (companyId?: string) => {
        try {
            const response: any = await getEstablishmentsApi(companyId);
            return response;
        } catch (error) {
            toast.error("Error al obtener los establecimientos");
            throw error;
        }
    }
);

export const addEstablishment = createAsyncThunk(
    "companies/addEstablishment",
    async (establishment: any) => {
        try {
            const response: any = await addEstablishmentApi(establishment);
            toast.success("Establecimiento agregado con éxito");
            return response;
        } catch (error) {
            toast.error("Error al agregar el establecimiento");
            throw error;
        }
    }
);

export const updateEstablishment = createAsyncThunk(
    "companies/updateEstablishment",
    async (establishment: any) => {
        try {
            const response: any = await updateEstablishmentApi(establishment);
            toast.success("Establecimiento actualizado con éxito");
            return response;
        } catch (error) {
            toast.error("Error al actualizar el establecimiento");
            throw error;
        }
    }
);

export const deleteEstablishment = createAsyncThunk(
    "companies/deleteEstablishment",
    async (id: string) => {
        try {
            await deleteEstablishmentApi(id);
            toast.success("Establecimiento eliminado con éxito");
            return id;
        } catch (error) {
            toast.error("Error al eliminar el establecimiento");
            throw error;
        }
    }
);

// Emission Points
export const getEmissionPoints = createAsyncThunk(
    "companies/getEmissionPoints",
    async (establishmentId?: string) => {
        try {
            const response: any = await getEmissionPointsApi(establishmentId);
            return response;
        } catch (error) {
            toast.error("Error al obtener los puntos de emisión");
            throw error;
        }
    }
);

export const addEmissionPoint = createAsyncThunk(
    "companies/addEmissionPoint",
    async (emissionPoint: any) => {
        try {
            const response: any = await addEmissionPointApi(emissionPoint);
            toast.success("Punto de emisión agregado con éxito");
            return response;
        } catch (error) {
            toast.error("Error al agregar el punto de emisión");
            throw error;
        }
    }
);

export const updateEmissionPoint = createAsyncThunk(
    "companies/updateEmissionPoint",
    async (emissionPoint: any) => {
        try {
            const response: any = await updateEmissionPointApi(emissionPoint);
            toast.success("Punto de emisión actualizado con éxito");
            return response;
        } catch (error) {
            toast.error("Error al actualizar el punto de emisión");
            throw error;
        }
    }
);

export const deleteEmissionPoint = createAsyncThunk(
    "companies/deleteEmissionPoint",
    async (id: string) => {
        try {
            await deleteEmissionPointApi(id);
            toast.success("Punto de emisión eliminado con éxito");
            return id;
        } catch (error) {
            toast.error("Error al eliminar el punto de emisión");
            throw error;
        }
    }
);
